<ion-list lines="full">
  <ion-item
    [class.active-step]="currentAutopayStep === autopaySteps.stepOne"
    (click)="changeAutopayStep(autopaySteps.stepOne)"
    detail="true"
    detail-icon="chevron-forward-outline"
    data-cy="autopay-step-1"
  >
    <ion-label
      >{{ 'i18n.payments.addBankAccountModal.accountType' | translate }}
      {{
        'i18n.payments.addBankAccountModal.stepNumber'
          | translate: { number: autopaySteps.stepOne }
      }}
      <p *ngIf="isStepOneCompleted">
        {{ 'i18n.common.completed' | translate }}
      </p>
    </ion-label>
  </ion-item>
  <ion-item
    [class.active-step]="currentAutopayStep === autopaySteps.stepTwo"
    (click)="changeAutopayStep(autopaySteps.stepTwo)"
    detail="true"
    detail-icon="chevron-forward-outline"
    data-cy="autopay-step-2"
  >
    <ion-label
      >{{ 'i18n.payments.addBankAccountModal.customer' | translate }}
      {{
        'i18n.payments.addBankAccountModal.stepNumber'
          | translate: { number: autopaySteps.stepTwo }
      }}
      <p *ngIf="isStepTwoCompleted">
        {{ 'i18n.common.completed' | translate }}
      </p>
    </ion-label>
  </ion-item>
  <ion-item
    [class.active-step]="currentAutopayStep === autopaySteps.stepThree"
    (click)="changeAutopayStep(autopaySteps.stepThree)"
    detail="true"
    detail-icon="chevron-forward-outline"
    data-cy="autopay-step-3"
  >
    <ion-label
      >{{ 'i18n.payments.addBankAccountModal.effectiveDate' | translate }}
      {{
        'i18n.payments.addBankAccountModal.stepNumber'
          | translate: { number: autopaySteps.stepThree }
      }}
      <p *ngIf="isStepThreeCompleted">
        {{ 'i18n.common.completed' | translate }}
      </p>
    </ion-label>
  </ion-item>
</ion-list>
